export default "__VITE_ASSET__6529ad23__"